/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Studio_OneInputs */

const en_platform_team_studio_one = /** @type {(inputs: Platform_Team_Studio_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Several coaches on one schedule`)
};

const pl_platform_team_studio_one = /** @type {(inputs: Platform_Team_Studio_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilku trenerów w jednym grafiku`)
};

/**
* | output |
* | --- |
* | "Several coaches on one schedule" |
*
* @param {Platform_Team_Studio_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_studio_one = /** @type {((inputs?: Platform_Team_Studio_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Studio_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_studio_one(inputs)
	return en_platform_team_studio_one(inputs)
});